module.exports = __webpack_public_path__ + "static/media/sysedit_2.47040c92.ico";